<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
            <BackLink/>
            <Section :section="this.sectionId" />
        </div>
        <Form
            :data="form"
            :error="$v.form.$error"
            :formId="question.id"
            :formErrorMessage="errorMessage"
            @submit="submitNameAndGender">
            <Fieldset 
                :title="question">
                
                <div class="grid-col grid-xsmall-12 grid-large-5">
                    <TextInput
                        id="streetnumber"
                        name="streetnumber"
                        label="Street Number"
                        errorMessage="Street number is a required field."
                        v-model="form.streetnumber"
                        :validate="$v.form.streetnumber"
                    />   
                </div>
                <TextInput
                    id="streetname"
                    name="streetname"
                    label="Street Name"
                    errorMessage="Street Name is a required field."
                    v-model="form.streetname"
                    :validate="$v.form.streetname"
                />   
                <TextInput
                    id="towncity"
                    name="towncity"
                    label="Town / City"
                    errorMessage="Town / City is a required field."
                    v-model="form.towncity"
                    :validate="$v.form.towncity"
                />   
                <div class="grid-col grid-xsmall-12 grid-large-5">
                    <TextInput
                        id="postcode"
                        name="postcode"
                        label="Postcode"
                        :errorMessage="'Postcode' + validationMsg($v.form.postcode)"
                        v-model="form.postcode"
                        :validate="$v.form.postcode"
                    />
                </div>
            </Fieldset>
        </Form>
      </article>
    </div>
  </div>
</template>

<script>
import { helpers, required } from "vuelidate/lib/validators";
import { validationMessage } from 'vuelidate-messages';
import { dataService } from "../shared";
const validPostcode = helpers.regex('postcode', /^([A-Za-z][A-Ha-hJ-Yj-y]?\d[A-Z\d]? ?\d[A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/)

const formMessages = {
    required: () => ' is a required field.',
    validPostcode: () => ' must be a valid UK postcode.'
}

export default {
  name: "home",
  props: {
        title: String
  },
  data() {
        return {
            id: "",
            sectionId: null,
            question: "",
            errorMessage: "All fields are required",
            detailsTitle: "",
            destination: "",
            form: {
                towncity: null,
                streetnumber: null,
                streetname: null,
                postcode: null
            }
        };
    },
    created() {
        this.loadQuestion();
    },  
    mounted() {
        this.loadAnswer();
    },
    validations: {
        form: {
            towncity: {required},
            streetnumber: {required},
            streetname: {required},
            postcode: {required, validPostcode}
        }
    },
    methods: {
        validationMsg: validationMessage(formMessages),
        submitForm(form, valid) {
            valid.$touch();
            if (valid.$pending || valid.$error) {
                setTimeout(() => {
                    document.querySelector(".error-summary__link").focus()
                }, 0);
                return;	
            }    
            this.logResponse();
            if (dataService.canShowSummary())
            {
                this.$router.push({ name: "summary" });
            }
            else
            {
                this.$router.push({ name: this.destination.toLowerCase() });
            }
        },
        submitNameAndGender() {
            this.submitForm(this.form, this.$v.form);
        },
        loadQuestion() {
            let json = dataService.getQuestions();
            let questions = json.questions;
            let currentQuestion = dataService.findElement(
                questions,
                dataService.parseUrl()
            );
            this.id = currentQuestion.id;
            this.sectionId = currentQuestion.sectionId;
            this.question = currentQuestion.question;
            this.errorMessage = currentQuestion.errorMessage;
            this.destination = currentQuestion.destination;
            let previousResponse = dataService.wasAnsweredBefore(currentQuestion.id);
            if (previousResponse) {
                this.form.id = previousResponse.id;
                this.form.responseId = previousResponse.id;
                this.form.towncity = previousResponse.towncity;
                this.form.streetname = previousResponse.streetname;
                this.form.streetnumber = previousResponse.streetnumber;
                this.form.postcode = previousResponse.postcode;
                this.form.response = previousResponse.response;                
            }
        },    
        loadAnswer() {
        },
        logResponse() {
            let response = {
                id: this.id,
                questionType: "AddressDetails",
                towncity : this.form.towncity,
                streetname : this.form.streetname,
                streetnumber : this.form.streetnumber,
                postcode : this.form.postcode,
                responseId: this.answer,
                response: this.form.response
            };
            dataService.logResponse(response);
        },
        redirectToTimeout() {
            dataService.resetResponses();
            this.$router.push({ name: "timeout" });
        }
    }
};
</script>